import React from 'react'
import PropTypes from 'prop-types'

import { Section } from '../../../entities/Section'

import i18n from '../../../config/i18n'

import { findNewsCategorySlug } from '../../../config/functions'

import { Description } from '../Description/Description'
import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'
import { DocumentList } from '../DocumentList/DocumentList'
import { GallerySlider } from '../GallerySlider/GallerySlider'
import { SectionBlock } from './../SectionBlock/SectionBlock'
import { ContactSection } from '../ContactSection/ContactSection'
import { FeaturedNewsSection } from '../WebPage/FeaturedNewsSection'
import { Hide } from '../Hide'
import VideoPlayer from '../VideoPlayer/VideoPlayer'

import './SectionList.css'
import OfficesAccordion from '../OfficesAccordion/OfficesAccordion'

const SectionItem = ({ section }) => {
    const {
        title,
        htmlDescription,
        split,
        docs,
        galleryImages,
        isDark,
        news,
        videos,
        offices,
        representatives,
        hasContacts,
        contacts
    } = section

    const showTitle = title !== i18n.t('contactSection.title')
    return (
        <>
            <SectionBlock withContainer dark={isDark}>
                {showTitle && <TopSectionTitle title={title} centered underlined dark={!isDark} />}
                <Description
                    split={split}
                    html={htmlDescription}
                    dark={isDark}
                    isUkraineInfo={
                        section.slug === 'ukrajina-dokumenti-i-informacije' ? true : false
                    }
                />
                <div className="section-item__gallery">
                    <GallerySlider galleryItems={galleryImages} />
                </div>
                <DocumentList documents={docs} dark={isDark} />
                <div className="section-item">
                    {news &&
                        news.map(({ id, name }) => {
                            const newsSectionTitle =
                                news.length > 1 ? name : i18n.t('news-section.title-default')
                            const categorySlug = findNewsCategorySlug(id)
                            return (
                                <FeaturedNewsSection
                                    categoryId={id}
                                    title={newsSectionTitle}
                                    link={`/sve-vesti/kategorija/${id}/${categorySlug}`}
                                    key={id}
                                    dark={isDark}
                                />
                            )
                        })}
                </div>
                <div className="video-gallery">
                    {videos.map((video, i) => (
                        <VideoPlayer videoUrl={video.documentUrl} title={video.title} key={i} />
                    ))}
                    {representatives && (
                        <OfficesAccordion
                            accordionList={representatives}
                            title={i18n.t('representativesTitle')}
                        />
                    )}
                    {offices && (
                        <OfficesAccordion accordionList={offices} title={i18n.t('officesTitle')} />
                    )}
                </div>
                <div className="section-item__contacts">
                    {hasContacts && <ContactSection contacts={contacts} dark={isDark} />}
                </div>
            </SectionBlock>
            <hr className="container-1280" />
        </>
    )
}

const SectionsList = ({ sections = [] }) => {
    const sectionItems = sections.map((section, i) => <SectionItem key={i} section={section} />)
    return <Hide ifEmpty={sections}>{sectionItems}</Hide>
}

SectionsList.propTypes = {
    section: PropTypes.arrayOf(PropTypes.instanceOf(Section))
}

export { SectionsList, SectionItem }
